import React, { useContext, useEffect, useState, useMemo } from 'react';
import { Switch } from '@mui/material';
import PlanCard from '../PlanCard/view';
import { getPlans } from '../../../usecases/subscriptions-usecase';
import { devicecontext } from '../../../context/device/context';
import './style.css';

function PlanDisplay({ onSelectPlan, currentPlan, roleId }) {
    const [allPlans, setAllPlans] = useState([]);
    const [isAnnual, setIsAnnual] = useState(true);
    const { isMobileDevice } = useContext(devicecontext);
    const isMobile = isMobileDevice();

    useEffect(() => {
        getPlans().then((res) => {
            const transformed = res.map((plan) => {
                const benefitsData = Object.entries(plan.benefits || {}).map(([key, value]) => {
                    const label = value?.label || key.replace(/_/g, ' ');
                    return label.charAt(0).toUpperCase() + label.slice(1);
                });
                return { ...plan, information: { data: benefitsData } };
            });

            const defaultUserType = roleId === 4 ? 'contador' : 'empresa';
            const userType = currentPlan?.user_type || defaultUserType;
            const filtered = transformed.filter((p) => !p.user_type || p.user_type === userType);

            setAllPlans(filtered);
        });
    }, [currentPlan, roleId]);

    const currentPlanId = currentPlan?.plan_id || currentPlan?.id;

    const plans = useMemo(() => {
        const withoutCurrent = allPlans.filter((p) => p.id !== currentPlanId);
        return withoutCurrent.filter((p) => p.billing_cycle === (isAnnual ? 'anual' : 'mensual'));
    }, [allPlans, currentPlanId, isAnnual]);

    const popularId = useMemo(() => {
        if (!plans.length) return null;
        const sorted = [...plans].sort((a, b) => (a.hierarchy || 0) - (b.hierarchy || 0));
        return sorted[Math.floor(sorted.length / 2)]?.id;
    }, [plans]);

    return (
        <section className="plan-display">
            <div className="plan-display__toggle">
                <span className={`plan-display__toggle-label ${isAnnual ? 'plan-display__toggle-label--active' : ''}`}>
                    Anual
                </span>
                <Switch
                    checked={!isAnnual}
                    onChange={(e) => setIsAnnual(!e.target.checked)}
                    sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': { color: 'var(--color-primary)' },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': { backgroundColor: 'var(--color-primary)' },
                        '& .MuiSwitch-track': { backgroundColor: 'rgba(100,100,100,0.25)' },
                    }}
                />
                <span className={`plan-display__toggle-label ${!isAnnual ? 'plan-display__toggle-label--active' : ''}`}>
                    Mensual
                </span>
            </div>

            <div className={`plan-display__grid ${isMobile ? 'plan-display__grid--mobile' : ''}`}>
                {plans.map((plan) => (
                    <PlanCard
                        key={plan.id}
                        plan={plan}
                        onSelect={onSelectPlan}
                        text={'Elegir'}
                        isPopular={plan.id === popularId}
                    />
                ))}
            </div>
        </section>
    );
}

export default PlanDisplay;
